import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { jsonp } from '@ifeng/ui_base';
import { Player } from 'ThreeTerminal_pc';
import Footer from '../../../components/footer/';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.css';
import Slider from 'react-slick';
import { footer } from './assets/data';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });
    if (name === '节目正片') {
        const newResult = [];

        const temp = result.map((item, index) => {
            return {
                videoPlayUrl: item.videoPlayUrl,
                guid: item.guid,
                thumbnail: item.thumbnail,
                duration: item.duration,
                title: item.title,
                summary: item.summary,
            };
        });

        temp.forEach((item, index) => {
            if (item.summary) {
                newResult[+item.summary - 1] = item;
            }
        });

        return newResult;
    }

    return result;
};
const pickStageContent = (data, stage) => {
    return data.filter((item, index) => {
        return item.summary === stage;
    });
};
const formatPlayNum = playNum => {
    let formated = '';

    if (playNum < 10000) {
        formated = playNum;
    } else {
        formated = `${(playNum / 10000).toFixed(1)}万`;
    }

    return formated;
};
// 视频模块
const Feature = errorBoundary(props => {
    // 这里不知道为什么reverse不生效
    const mainContent = pickContent(props, '节目正片');

    const videoNum = mainContent.filter((item, index) => !!item.videoPlayUrl).length;
    const [videoPlay, setVideoPlay] = useState(true);
    const [roundPlay, setRoundPlay] = useState(0);
    // 播放量
    const [playNum, setPlayNum] = useState(0);
    // 当前选中的视频
    const [activeIndex, setActiveIndex] = useState(videoNum - 1);
    // 获取播放量
    const getVideoComment = async vid => {
        let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

        // 接口拼接
        if (vid.length > 0) {
            vid.forEach(item => {
                apiUrl += `key[]=${item}&`;
            });
        }
        let data = await jsonp(apiUrl, {
            data: {
                format: 'js',
                serviceid: 1,
            },
            jsonpCallback: 'getVideoComment1',
            cache: false,
        });

        data = data.data.browse[vid];
        setPlayNum(data);
    };

    useEffect(
        () => {
            setVideoPlay(true);
            getVideoComment([mainContent[activeIndex].guid]);
        },
        [activeIndex],
    );
    useEffect(() => {
        // 获取观看量
        getVideoComment([mainContent[activeIndex].guid]);
    }, []);

    const changeVideo = index => {
        if (activeIndex !== index) {
            window.videoOrderList = undefined;
            setVideoPlay(false);
            setActiveIndex(index);
        }
    };
    const playNextVideo = _ => {
        // 循环播放
        window.videoOrderList = undefined;
        setVideoPlay(false);
        if (activeIndex + 1 < videoNum) {
            setActiveIndex(activeIndex + 1);
        } else if (activeIndex + 1 === videoNum && activeIndex !== 0) {
            setActiveIndex(0);
        } else {
            setRoundPlay(roundPlay + 1);
        }
    };

    const handleClick = index => {
        if (index < videoNum) {
            changeVideo(index);
        }
    };

    useEffect(
        () => {
            setVideoPlay(true);
        },
        [activeIndex, roundPlay],
    );

    return (
        <div className={styles.feature}>
            <div className={styles.video_container}>
                {videoPlay ? (
                    <Player
                        videoConfig={{
                            videoLargePoster: mainContent[activeIndex].thumbnail,
                            videoPlayUrl: mainContent[activeIndex].videoPlayUrl,
                            duration: +mainContent[activeIndex].duration,
                            vid: mainContent[activeIndex].guid,
                        }}
                        playermsg={{
                            subject: '7tEKsfKmm4e',
                            adType: 2,
                            width: 800,
                            height: 450,
                            isAuth: 'auth',
                            frmid: 'v',
                            autoPlay: true,
                            playerEventTrigger: playerEvents => {
                                playerEvents.on('ended', () => {
                                    playNextVideo();
                                });
                            },
                        }}
                    />
                ) : null}
            </div>
            <div className={styles.playNum}>{`${formatPlayNum(playNum)}播放`}</div>
            <div className={styles.video_list}>
                {mainContent.map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={handleClick.bind(this, index)}
                            className={`${styles.video_list_item} ${
                                index === activeIndex ? styles.video_list_item_active : ''
                            } ${index >= videoNum ? styles.video_list_item_disable : ''}`}>
                            <img src={item.thumbnail} alt="" />
                            <div title={item.title}>{item.title}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
// 图集
const Atlas = errorBoundary(props => {
    const atlas = pickContent(props, '暖图集');
    const content = [pickStageContent(atlas, '1'), pickStageContent(atlas, '2'), pickStageContent(atlas, '3')];
    const [stage, setStage] = useState(1);
    const [stageContent, setStateContent] = useState(content[0]);
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const changeStage = index => {
        if (content[index - 1].length) {
            setStage(index);
            setStateContent(content[index - 1]);
        }
    };
    const formateData = [];
    const tempList = stageContent[0].thumbnails.image || [];

    tempList.forEach((item, index) => {
        const key = parseInt(index / 4);

        item.num = tempList.length - index < 10 ? `0${tempList.length - index}` : tempList.length - index;

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });
    formateData.forEach((item, index) => {
        while (formateData[index].length < 4) {
            formateData[index].push('');
        }
    });

    return (
        <div className={styles.atlas}>
            <div className={styles.atlas_title} />
            <div className={styles.stage_container}>
                <div
                    className={`${styles.stage} ${stage === 1 ? styles.stage_active : ''}`}
                    onClick={_ => {
                        changeStage(1);
                    }}>
                    第一期
                </div>
                <div
                    className={`${styles.stage} ${!content[1].length ? styles.stage_disable : ''} ${
                        stage === 2 ? styles.stage_active : ''
                    }`}
                    onClick={_ => {
                        changeStage(2);
                    }}>
                    第二期
                </div>
                <div
                    className={`${styles.stage} ${!content[2].length ? styles.stage_disable : ''} ${
                        stage === 3 ? styles.stage_active : ''
                    }`}
                    onClick={_ => {
                        changeStage(3);
                    }}>
                    第三期
                </div>
            </div>
            <div className={styles.atlas_container}>
                <div
                    className={styles.slide_pre}
                    onClick={() => {
                        slide.current.slickPrev();
                    }}
                />
                <div className={styles.slide_next} onClick={() => slide.current.slickNext()} />
                <Slider {...settings} ref={slider => (slide.current = slider)} key={stage}>
                    {formateData.map((item, _index) => {
                        return (
                            <div key={_index} className={styles.slide}>
                                {item.map((card, index) => {
                                    if (card) {
                                        return (
                                            <div
                                                key={index}
                                                className={styles.slide_item}
                                                onClick={() =>
                                                    window.open(
                                                        `${stageContent[0].url}#p=${_index * 4 + index + 1}`,
                                                        '_blank',
                                                    )
                                                }>
                                                <img src={card.url} alt="" />
                                            </div>
                                        );
                                    } else {
                                        return <div key={index} className={styles.slide_item} />;
                                    }
                                })}
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
});
// 短片
const ShortVideos = errorBoundary(props => {
    const shortVideos = pickContent(props, '暖短片');
    const content = [
        pickStageContent(shortVideos, '1'),
        pickStageContent(shortVideos, '2'),
        pickStageContent(shortVideos, '3'),
    ];
    const [stage, setStage] = useState(1);
    const [stageContent, setStateContent] = useState(content[0]);
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const changeStage = index => {
        if (content[index - 1].length) {
            setStage(index);
            setStateContent(content[index - 1]);
        }
    };
    const formateData = [];
    const tempList = stageContent;

    tempList.forEach((item, index) => {
        const key = parseInt(index / 4);

        item.num = tempList.length - index < 10 ? `0${tempList.length - index}` : tempList.length - index;

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });
    formateData.forEach((item, index) => {
        while (formateData[index].length < 4) {
            formateData[index].push('');
        }
    });

    return (
        <div className={styles.shortVideos}>
            <div className={styles.shortVideos_title} />
            <div className={styles.stage_container}>
                <div
                    className={`${styles.stage} ${stage === 1 ? styles.stage_active : ''}`}
                    onClick={_ => {
                        changeStage(1);
                    }}>
                    第一期
                </div>
                <div
                    className={`${styles.stage} ${!content[1].length ? styles.stage_disable : ''} ${
                        stage === 2 ? styles.stage_active : ''
                    }`}
                    onClick={_ => {
                        changeStage(2);
                    }}>
                    第二期
                </div>
                <div
                    className={`${styles.stage} ${!content[2].length ? styles.stage_disable : ''} ${
                        stage === 3 ? styles.stage_active : ''
                    }`}
                    onClick={_ => {
                        changeStage(3);
                    }}>
                    第三期
                </div>
            </div>
            <div className={styles.slide_container}>
                <div
                    className={styles.slide_pre}
                    onClick={() => {
                        slide.current.slickPrev();
                    }}
                />
                <div className={styles.slide_next} onClick={() => slide.current.slickNext()} />
                <Slider {...settings} ref={slider => (slide.current = slider)} key={stage}>
                    {formateData.map((item, _index) => {
                        return (
                            <div key={_index} className={styles.slide}>
                                {item.map((card, index) => {
                                    if (card) {
                                        return (
                                            <div
                                                key={index}
                                                className={styles.slide_item}
                                                onClick={() => window.open(card.url, '_blank')}>
                                                <img src={card.thumbnail} alt="" />
                                                <div className={styles.stage_title}>{card.title}</div>
                                                <span />
                                            </div>
                                        );
                                    } else {
                                        return <div key={index} className={styles.slide_item} />;
                                    }
                                })}
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
});
// 暖暖故事
const Story = errorBoundary(props => {
    const story = pickContent(props, '暖故事');

    while (story.length < 4) {
        story.push('');
    }

    return (
        <div className={styles.story}>
            <div className={styles.story_title} />
            <div className={styles.story_container}>
                <div className={styles.story_line} />
                <div className={styles.story_line} />
                {story.map((item, index) => {
                    if (item) {
                        return (
                            <div
                                className={styles.story_item}
                                key={index}
                                title={item.title}
                                onClick={_ => {
                                    window.open(item.url, '_blank');
                                }}>
                                {item.title}
                            </div>
                        );
                    } else {
                        return <div className={styles.story_item_empty} key={index} title={item.title} />;
                    }
                })}
            </div>
        </div>
    );
});
// 特别鸣谢
const Acknowledge = errorBoundary(props => {
    return (
        <div className={styles.acknowledge}>
            <div className={styles.thanks_title} />
            <div
                className={styles.thanks_logo}
                onClick={_ => {
                    window.open('https://mall.jd.com/index-1000089246.html', '_blank');
                }}
            />
        </div>
    );
});

// 评论
const Comment = errorBoundary(props => {
    return (
        <div className={styles.comment}>
            <div className={styles.comment_title} />
            <div className={styles.iframe_container}>
                <iframe
                    src="http://widget.weibo.com/topics/topic_vote_base.php?uid=7087906569&amp;border=0&amp;footbar=1
                        &amp;width=998&amp;height=665&amp;language=zh_cn&amp;version=base
                        &amp;isshowright=1&amp;tag=%E6%9A%96%E6%9A%96%E7%9A%84%E4%B8%AD%E5%9B%BD
                        "
                    width="998"
                    height="665"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                />
            </div>
        </div>
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.warm_china}>
                <div className={styles.head_img}>
                    <div className={styles.big_logo} />
                    <div className={styles.logo_group} />
                    <div className={styles.brand} />
                </div>
                <Feature content={content} />
                <ShortVideos content={content} />
                <Atlas content={content} />
                <Story content={content} />
                <Acknowledge content={content} />
                <Comment content={content} />
                <div className={styles.footer_line} />
                <Footer content={footer.content} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
